var _rect, _rect2, _rect3, _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Svg3YearChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 71,
    viewBox: "0 0 53 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38.1602,
    width: 14.84,
    height: 50.9466,
    rx: 3,
    fill: "#00c6c4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.08,
    y: 11.8996,
    width: 14.84,
    height: 42.9862,
    rx: 3,
    fill: "#00c6c4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 27.0244,
    width: 14.84,
    height: 35.8218,
    rx: 3,
    fill: "#00c6c4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.1602 19.105H53.0002V67.0516C53.0002 68.7084 51.657 70.0516 50.0002 70.0516H41.1602C39.5033 70.0516 38.1602 68.7084 38.1602 67.0516V19.105Z",
    fill: "#7163D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.08 31.8416H33.92V67.0516C33.92 68.7084 32.5768 70.0516 30.92 70.0516H22.08C20.4231 70.0516 19.08 68.7084 19.08 67.0516V31.8416Z",
    fill: "#7163D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 42.1901H14.84V67.0515C14.84 68.7084 13.4969 70.0515 11.84 70.0515H3C1.34315 70.0515 0 68.7084 0 67.0515V42.1901Z",
    fill: "#7163D0"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3YearChart);
export default __webpack_public_path__ + "static/media/3-year-chart.1fd3fd83.svg";
export { ForwardRef as ReactComponent };